import useFetch from 'hooks/useFetch';
import React, { FC, useState, useEffect } from 'react';
import config from 'config.json';
import Input from 'shared/Input/Input';

interface ModalProps {
    message?: string;
    title?: string;
    isModalOpen: boolean;
    handleModalClose: () => void;
    userData: User;
}

interface User {
    id: number;
    firstname: string;
    lastname: string;
    document: string;
    mail: string;
    phones: Phone[];
    fecha_nacimiento: string;
    observations: string;
    semaphore_status: number;
}

interface Phone {
    phone_number: string;
    active: boolean;
}

const modalStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

interface IbodyUpdate {
    id_user: number;
    first_name: string;
    last_name: string;
    old_phone: string;
    new_phone: string;
    semaphore_status: string;
    observations: string;
    mail: string;
}

const EditUserData: FC<ModalProps> = ({ userData, isModalOpen, handleModalClose }) => {
    const [bodyUpdate, setBodyUpdate] = useState<IbodyUpdate>({
        id_user: userData.id,
        first_name: userData.firstname,
        last_name: userData.lastname,
        old_phone: userData.phones[0].phone_number,
        new_phone: userData.phones[0].phone_number,
        semaphore_status: userData.semaphore_status.toString(),
        observations: userData.observations,
        mail: userData.mail
    });

    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const { data, error, isLoading, fetchData } = useFetch(
        "PUT",
        `${config.backend_url}/authe/update`,
        bodyUpdate,
        { 'Content-Type': 'application/json', 'SetiaAuthorization': `${sessionStorage.getItem('user_token')}` }
    );

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setBodyUpdate({
            ...bodyUpdate,
            [name]: value
        });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        await fetchData();
    };

    useEffect(() => {
        if (error) {
            setErrorMessage("No se pudo actualizar los datos"); // Guarda el mensaje de error
            setShowErrorModal(true); // Muestra el modal de error
        }
        if(data){
            setShowSuccessModal(true); // Muestra el modal de éxito
        }
    }, [data,error]);

    const handleSuccessModalClose = () => {
        setShowSuccessModal(false);
        window.location.reload(); // Refresh the page after the success modal is closed
    };

    const handleErrorModalClose = () => {
        setShowErrorModal(false);
    };

    if (!isModalOpen) {
        return null;
    }

    return (
        <>
            <div className="fixed z-40 inset-0 overflow-y-auto" id="my-modal">
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0 sm:h-screen sm:items-center sm:flex sm:w-50% " style={modalStyle}>
                    <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                        <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div className="inline-block align-bottom bg-white max-h-[80vh] rounded-lg px-4 pt-5 pb-4 text-left overflow-y-auto min-w-[50vw] max-w-4xl shadow-xl transform transition-all "
                        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <h2 className="text-2xl font-semibold mb-4 text-center">Editar datos del usuario</h2>
                        <p className='my-2 text-center'>Nota: Si cambias el telefono, deberas volver a verificar el nuevo telefono</p>
                        <form onSubmit={handleSubmit}>
                            <div className="flex justify-center">
                                <div className="flex-grow lg:flex lg:flex-wrap  md:mt-0  max-w-3xl space-y-6 ">
                                    <div className="lg:w-1/2 lg:p-2 lg:mt-6">
                                        <label htmlFor="firstname" className="block text-sm font-medium">Nombre:</label>
                                        <Input
                                            type="text"
                                            name="first_name"
                                            value={bodyUpdate.first_name}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border rounded"
                                            required
                                        />
                                    </div>

                                    <div className="lg:w-1/2 lg:p-2">
                                        <label htmlFor="lastname" className="block text-sm font-medium">Apellido:</label>
                                        <Input
                                            type="text"
                                            name="last_name"
                                            value={bodyUpdate.last_name}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border rounded"
                                            required
                                        />
                                    </div>

                                    {/* <div className="lg:w-1/2 lg:p-2">
                                        <label htmlFor="document" className="block text-sm font-medium">DNI:</label>
                                        <input
                                            type="text"
                                            name="document"
                                            value={userData.document}
                                            disabled
                                            className="w-full px-3 py-2 border rounded bg-gray-200"
                                        />
                                    </div> */}

                                    <div className="lg:w-1/2 lg:p-2">
                                        <label htmlFor="mail" className="block text-sm font-medium">Email:</label>
                                        <Input
                                            type="email"
                                            name="mail"
                                            value={bodyUpdate.mail}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border rounded"
                                            required
                                        />
                                    </div>

                                    <div className="lg:w-1/2 lg:p-2">
                                        <label htmlFor="phones" className="block text-sm font-medium">Teléfono:</label>
                                        <Input
                                            type="text"
                                            name="new_phone"
                                            value={bodyUpdate.new_phone}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border rounded"
                                            required
                                        />
                                    </div>

                                    {/* <div className="lg:w-1/2 lg:p-2">
                                        <label htmlFor="observations" className="block text-sm font-medium">Observaciones:</label>
                                        <Input
                                            type="text"
                                            name="observations"
                                            value={bodyUpdate.observations}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border rounded"
                                            required
                                        />
                                    </div> */}

                                    <div className="flex justify-center w-full mt-4">
                                        <button
                                            type="button"
                                            className="bg-red-500 text-white px-4 py-2 rounded-full mr-4"
                                            onClick={handleModalClose}
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            type="submit"
                                            className="bg-blue-500 text-white px-4 py-2 rounded-full"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? 'Guardando...' : 'Guardar cambios'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* Modal de éxito */}
            {showSuccessModal && (
                <div className="fixed z-50 inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded shadow-lg">
                        <h2 className="text-xl font-semibold mb-4">¡Actualización exitosa!</h2>
                        <p>Los datos del usuario han sido actualizados correctamente.</p>
                        {bodyUpdate.old_phone !== bodyUpdate.new_phone && (
                            <p className="mt-2 text-red-500">Nota: Debe volver a verificar el nuevo teléfono.</p>
                        )}
                        <div className="mt-4 flex justify-end">
                            <button
                                className="bg-blue-500 text-white px-4 py-2 rounded"
                                onClick={handleSuccessModalClose}
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}

             {/* Modal de error */}
             {showErrorModal && (
                <div className="fixed z-50 inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded shadow-lg">
                        <h2 className="text-xl font-semibold mb-4">¡Error al actualizar!</h2>
                        <p>{errorMessage || 'Ocurrió un error inesperado. Inténtalo de nuevo más tarde.'}</p>
                        <div className="mt-4 flex justify-end">
                            <button
                                className="bg-red-500 text-white px-4 py-2 rounded"
                                onClick={handleErrorModalClose}
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default EditUserData;
